(function () {
  'use strict';

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function sourceLabel(mall) {
    return { rakuten: '楽天市場', amazon: 'Amazon', yahoo: 'Yahoo!ショッピング' }[mall] || mall;
  }

  function starMarkup(value, className = '', label = '') {
    const numeric = Number(value);
    if (!Number.isFinite(numeric)) return '';
    // 星の見た目だけ0.5刻みに丸め、平均点の数字は元の値をそのまま表示する。
    const visualValue = Math.max(0, Math.min(5, Math.round(numeric * 2) / 2));
    const stars = Array.from({ length: 5 }, (_, index) => {
      const fill = visualValue >= index + 1 ? 'full' : visualValue >= index + 0.5 ? 'half' : 'empty';
      return `<span class="ec-review-insights-star ec-review-insights-star--${fill}" aria-hidden="true">${fill === 'empty' ? '☆' : '★'}</span>`;
    }).join('');
    const classes = ['ec-review-insights-stars', className].filter(Boolean).join(' ');
    const accessibility = label
      ? ` role="img" aria-label="${escapeHtml(label)}"`
      : ' aria-hidden="true"';
    return `<span class="${classes}"${accessibility}>${stars}</span>`;
  }

  function percentageValue(value) {
    const numeric = Number(value);
    if (!Number.isFinite(numeric)) return 0;
    return Math.max(0, Math.min(100, numeric));
  }

  function percentageText(value, maximumFractionDigits = 0) {
    const numeric = percentageValue(value);
    return numeric.toLocaleString('ja-JP', { maximumFractionDigits });
  }

  function getNativeRatingWrapper() {
    return document.querySelector('.product__info-container .rating-wrapper')
      || document.querySelector('.product__info-container .product__rating')
      || document.querySelector('.rating-wrapper');
  }

  function hideNativeRating() {
    const wrapper = getNativeRatingWrapper();
    if (!wrapper) return;
    wrapper.hidden = true;
    wrapper.classList.remove('ec-review-insights-native-rating--ready');
  }

  function syncNativeRating(insight, anchor) {
    const wrapper = getNativeRatingWrapper();
    if (!wrapper) return;

    const reviewCount = Number(insight.reviewCount) || 0;
    const average = insight.rating?.average == null ? NaN : Number(insight.rating.average);
    if (reviewCount < 1 || !Number.isFinite(average)) {
      wrapper.hidden = true;
      return;
    }

    const averageText = average.toFixed(2);
    const countText = reviewCount.toLocaleString('ja-JP');
    const anchorId = anchor.id || '';
    wrapper.innerHTML = `
      <a class="ec-review-insights-native-rating" href="#${escapeHtml(anchorId)}" aria-label="平均評価${escapeHtml(averageText)}点、${escapeHtml(countText)}件のレビュー。レビュー要約へ移動">
        ${starMarkup(average, 'ec-review-insights-native-rating__stars')}
        <span class="ec-review-insights-native-rating__score">${escapeHtml(averageText)}<small>/5</small></span>
        <span class="ec-review-insights-native-rating__count">（${escapeHtml(countText)}件）</span>
      </a>
    `;
    wrapper.hidden = false;
    wrapper.dataset.ecReviewInsightsRating = 'synced';
    wrapper.classList.add('ec-review-insights-native-rating--ready');
  }

  function render(insight, content) {
    const sourceText = Object.entries(insight.sourceCounts || {})
      .map(([mall, count]) => `${sourceLabel(mall)} ${Number(count).toLocaleString()}件`)
      .join('・');
    const reviewCount = Number(insight.reviewCount) || 0;
    const average = insight.rating?.average == null ? null : Number(insight.rating.average);
    const topicCards = (insight.topics || []).map(topic => `
      <article class="ec-review-insights__topic">
        <strong class="ec-review-insights__topic-percent">${escapeHtml(percentageText(topic.percentage))}%</strong>
        <h3>${escapeHtml(topic.title)}</h3>
        <div class="ec-review-insights__topic-rule" aria-hidden="true"></div>
        <p>${escapeHtml(topic.description)}</p>
        <span class="ec-review-insights__topic-count">${Number(topic.count).toLocaleString()}件のお客様の声</span>
      </article>
    `).join('');
    const caveats = (insight.caveats || []).map(caveat => `
      <li><strong>${escapeHtml(caveat.title)}：</strong>${escapeHtml(caveat.description)}（${Number(caveat.count).toLocaleString()}件）</li>
    `).join('');
    const disclosureText = sourceText
      ? `${sourceText}（合計${reviewCount.toLocaleString()}件）の同一商品レビューを、原文を掲載せずテーマ別に集計しています。個人の感想であり、商品の効果を保証するものではありません。`
      : insight.disclosure || '';

    content.innerHTML = `
      <p class="ec-review-insights__lead">${reviewCount.toLocaleString()}件のお客様レビューから、「${escapeHtml(insight.productName)}」が選ばれている理由をまとめました。</p>
      <div class="ec-review-insights__summary">
        ${average == null ? '' : `<div class="ec-review-insights__summary-rating">${starMarkup(average, 'ec-review-insights__summary-stars', `平均評価${average.toFixed(2)}点`)}<strong>${escapeHtml(average.toFixed(2))}<small>/5</small></strong><span>・${reviewCount.toLocaleString()}件</span></div>`}
      </div>
      <div class="ec-review-insights__topics">${topicCards}</div>
      <p class="ec-review-insights__overlap">※1件のレビューが複数のテーマに該当する場合があります。</p>
      ${caveats ? `<details class="ec-review-insights__caveats" open><summary><span class="ec-review-insights__caveats-icon" aria-hidden="true">i</span><span>ご購入前に知っておきたいこと</span></summary><ul>${caveats}</ul></details>` : ''}
      <p class="ec-review-insights__disclosure">${escapeHtml(disclosureText)}</p>
      <p class="ec-review-insights__updated">最終更新：${escapeHtml(insight.generatedAt.slice(0, 10))}</p>
    `;
  }

  function mount(root) {
    const endpoint = root.dataset.endpoint || '';
    const status = root.querySelector('[data-insights-status]');
    const content = root.querySelector('[data-insights-content]');
    if (!endpoint || !status || !content) return;

    // 集約値が返るまで旧Shopify評価を出さない。API障害時に数値が食い違うのを防ぐ。
    hideNativeRating();
    fetch(endpoint, { credentials: 'omit', headers: { Accept: 'application/json' } })
      .then(response => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.json();
      })
      .then(insight => {
        render(insight, content);
        syncNativeRating(insight, root);
        status.remove();
        root.hidden = false;
      })
      .catch(() => {
        // 商品ページには空の枠を残さず、集計API障害時は旧評価も表示しない。
        hideNativeRating();
        root.remove();
      });
  }

  function boot() {
    document.querySelectorAll('[data-ec-review-insights]').forEach(mount);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
